const groupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.PROMOTION_RULES)
const groupPrefixStore = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.PROMOTIONS)

export const apiPromotionRules = {
	fetchPromotionRulesTypes: async () => {
		const { data } = await apiCommon<IPromotion[]>(`${groupPrefix}/types`, {
			method: 'GET',
		})
		return { data }
	},

	fetchPromotionRule: async (ruleID: number) => {
		const { data } = await apiCommon<IPromotion>(`${groupPrefix}/${ruleID}`, {
			method: 'GET',
		})
		return { data: Promotion(data) }
	},

	storePromotionRule: async (promotionID: number, type: any, configuration: any) => {
		const { data } = await apiCommon<IPromotion>(`${groupPrefixStore}/${promotionID}/promotion-rules`, {
			method: 'POST',
			body: { type, configuration },
		})
		return Promotion(data)
	},

	updatePromotionRule: async (ruleID: number, type: any, configuration: any) => {
		const { data } = await apiCommon<IPromotion>(`${groupPrefix}/${ruleID}`, {
			method: 'PUT',
			body: { type, configuration },
		})
		return Promotion(data)
	},

	deletePromotionRule: async (ruleID: number) =>
		await apiCommon<IPromotion>(`${groupPrefix}/${ruleID}`, { method: 'DELETE' }),
}
